import formatSelectedItemsContext from 'common/src/modules/shared/copilot/utils/formatSelectedItemsContext';
import {AgentContext} from 'common/src/modules/shared/copilot/copilot.types';
import {CLStore} from 'common/src/redux/store';

type CreativesLibraryContext = {
  selectedCreatives: {
    id: number;
    name: string;
  }[];
};

export default function creativesLibraryContext(
  store: CLStore,
): AgentContext<CreativesLibraryContext> {
  return {
    title: 'Creatives library',
    getter: (): CreativesLibraryContext => {
      const {creatives, selectedCreativesIds} = store.getState().creativesLibrary;

      const selectedCreatives = creatives
        .filter((creative) => selectedCreativesIds.includes(creative.id))
        .map((creative) => ({
          id: creative.id,
          name: creative.name,
        }));

      return {selectedCreatives};
    },

    formatter: ({currentContext}) => {
      return formatSelectedItemsContext({
        items: currentContext.selectedCreatives,
        itemTypeName: 'creative',
      });
    },
  };
}
